/* Cleared Solo print designer.
   Works inside a Shopify product form: every choice is a line item property, so it shows up on the order.
   Markup contract: a [data-designer] root containing a JSON catalog, [data-f] fields, [data-tpls], [data-swatches],
   [data-cert] preview, and hidden [data-out] inputs. */
(function(){
"use strict";
const root = document.querySelector("[data-designer]");
if (!root) return;

const TEMPLATES = [
  {id:"sectional", name:"Sectional",     note:"Chart paper, magenta border"},
  {id:"shirttail", name:"Shirt Tail",    note:"Marker on oxford cloth"},
  {id:"night",     name:"Night Ops",     note:"Dark sky, amber glow"},
  {id:"runway",    name:"Runway",        note:"Painted numbers on asphalt"},
  {id:"boarding",  name:"Boarding Pass", note:"Great for airline milestones"},
  {id:"logbook",   name:"Logbook Page",  note:"Your entry, signed in pen"},
  {id:"blueprint", name:"Blueprint",     note:"Drawing with a title block"},
  {id:"vintage",   name:"Barnstormer",   note:"1930s poster with wings"},
  {id:"minimal",   name:"Minimal",       note:"Clean type, open space"},
  {id:"patch",     name:"Mission Patch", note:"Round badge with your name"}
];
const SWATCHES = [["","Template default"],["#A3206C","Magenta"],["#1E3A6E","Navy"],["#B3261E","Crimson"],["#2F6B3B","Forest"],["#C99A2E","Gold"],["#2E86C1","Sky"],["#2B2F35","Charcoal"]];
const FONTS = [["","Template default"],["hand","Handwritten"],["block","Block capitals"],["classic","Classic serif"],["type","Typewriter"]];
const MONTHS = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
const CUSTOM = "Custom milestone";

let CATALOG = [];
try { CATALOG = JSON.parse((root.querySelector("[data-catalog]") || {}).textContent || "[]"); } catch (err) { CATALOG = []; }
const SIGNER = {};
CATALOG.forEach(g => (g.items || []).forEach(([n, s]) => { SIGNER[n] = s || "Instructor"; }));

const q = sel => root.querySelector(sel);
const f = name => root.querySelector(`[data-f="${name}"]`);
const val = name => { const el = f(name); return el ? el.value.trim() : ""; };
const esc = s => String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
const uid = Math.random().toString(36).slice(2, 7);

/* ---------- build controls ---------- */
function buildControls(){
  const sel = f("milestone");
  if (sel && !sel.options.length) {
    CATALOG.forEach(g => {
      const og = document.createElement("optgroup"); og.label = g.group;
      (g.items || []).forEach(([n]) => { const o = document.createElement("option"); o.value = n; o.textContent = n; og.appendChild(o); });
      sel.appendChild(og);
    });
    const oc = document.createElement("option"); oc.value = CUSTOM; oc.textContent = "Custom milestone…"; sel.appendChild(oc);
    let want = "";
    try { want = new URLSearchParams(location.search).get("milestone") || ""; } catch (err) {}
    want = want || sel.dataset.default || "First Solo";
    if ([...sel.options].some(o => o.value === want)) sel.value = want;
  }
  const tp = q("[data-tpls]");
  if (tp) TEMPLATES.forEach((t, i) => {
    const l = document.createElement("label");
    l.innerHTML = `<input type="radio" name="${tp.dataset.name || "properties[Template]"}" value="${t.name}" data-tpl="${t.id}" id="tpl-${t.id}-${uid}"${i === 0 ? " checked" : ""}>${t.name}<small>${t.note}</small>`;
    tp.appendChild(l);
  });
  const sw = q("[data-swatches]");
  if (sw) {
    SWATCHES.forEach(([c, n], i) => {
      const l = document.createElement("label"); l.title = n;
      l.innerHTML = `<input type="radio" form="cs-no-submit" name="acc-${uid}" value="${c}" data-name="${n}" id="acc-${i}-${uid}"${i === 0 ? " checked" : ""} aria-label="${n}"><span${c ? ` style="--sw:${c}"` : ` class="def"`}></span>`;
      sw.appendChild(l);
    });
    const cl = document.createElement("label"); cl.title = "Custom color";
    cl.innerHTML = `<input type="radio" form="cs-no-submit" name="acc-${uid}" value="custom" data-name="Custom" id="acc-custom-${uid}" aria-label="Custom color"><span style="--sw:conic-gradient(#e53935,#fdd835,#43a047,#1e88e5,#8e24aa,#e53935)"></span>`;
    sw.appendChild(cl);
    const ci = document.createElement("input"); ci.type = "color"; ci.value = "#E4572E"; ci.setAttribute("data-f", "color"); ci.setAttribute("aria-label", "Pick a custom color");
    ci.addEventListener("input", () => { cl.querySelector("input").checked = true; render(); });
    sw.appendChild(ci);
  }
  const fs = f("font");
  if (fs && !fs.options.length) FONTS.forEach(([k, n]) => { const o = document.createElement("option"); o.value = n; o.dataset.nf = k; o.textContent = n; fs.appendChild(o); });
}

function fmtDate(v){
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || "");
  return m ? `${m[3]} ${MONTHS[+m[2] - 1]} ${m[1]}` : "DATE";
}
function fmtRwy(v){
  const s = (v || "").toUpperCase().replace(/\s/g, "");
  const m = /^(\d{1,2})([LCR]?)$/.exec(s);
  if (!m) return s || "—";
  return String(Math.min(Math.max(+m[1], 1), 36)).padStart(2, "0") + m[2];
}
const checked = sel => (root.querySelector(sel + ":checked") || {});

function vals(){
  const ms = val("milestone");
  const accEl = checked(`[data-swatches] input[type=radio]`);
  const acc = accEl.value === "custom" ? val("color") : (accEl.value || "");
  const fontOpt = f("font") ? f("font").selectedOptions[0] : null;
  const show = k => { const el = q(`[data-show="${k}"]`); return el ? el.checked : true; };
  return {
    milestone: ms === CUSTOM ? (val("custom") || "Your Milestone") : (ms || "First Solo"),
    isCustom: ms === CUSTOM,
    signer: SIGNER[ms] || "Signed by",
    name: val("name") || "Your Name",
    date: fmtDate(val("date")),
    apt: val("apt").toUpperCase() || "KXXX",
    type: val("type") || "Aircraft",
    tail: val("tail").toUpperCase().replace(/\s/g, "") || "N12345",
    rwy: fmtRwy(val("rwy")),
    cfi: val("cfi") || "Instructor",
    route: val("route").toUpperCase(),
    time: val("time"),
    note: val("note"),
    tpl: checked("[data-tpls] input").dataset ? (checked("[data-tpls] input").dataset.tpl || "sectional") : "sectional",
    layout: (checked("[data-layout]").value || "Landscape").toLowerCase(),
    acc,
    accName: accEl.value === "custom" ? "Custom " + val("color").toUpperCase() : (accEl.dataset ? accEl.dataset.name || "Template default" : "Template default"),
    font: fontOpt ? (fontOpt.dataset.nf || "") : "",
    showArt: show("art"), showDetails: show("details"), showRmk: show("rmk")
  };
}
/* ---------- shared pieces ---------- */
const PLANE = `<path d="M50 6c3 0 4 6 4 14v14l36 2v8l-36 2v20l12 1v6l-12 1-3 8h-2l-3-8-12-1v-6l12-1V46l-36-2v-8l36-2V20c0-8 1-14 4-14z"/>`;
function details(e){
  const d = [["Aircraft",e.type],["Tail",e.tail],["Runway",e.rwy],[e.signer,e.cfi]];
  if (e.route) d.push(["Route",e.route]);
  if (e.time) d.push(["Time",e.time + " hrs"]);
  return d;
}
const rmkText = e => `RMK ${e.milestone.toUpperCase()} · ${e.tail} · RWY ${e.rwy}${e.route ? " · " + e.route : ""}`;
const noteHtml = e => e.note ? `<div class="c-note">${e.note}</div>` : "";
function rwySvg(rwy){
  return `<svg viewBox="0 0 120 150" aria-hidden="true"><rect x="30" y="0" width="60" height="150" fill="#2C323A"/><g fill="#F4F6F1">
    <rect x="34" y="132" width="4" height="14"/><rect x="41" y="132" width="4" height="14"/><rect x="48" y="132" width="4" height="14"/><rect x="55" y="132" width="4" height="14"/>
    <rect x="61" y="132" width="4" height="14"/><rect x="68" y="132" width="4" height="14"/><rect x="75" y="132" width="4" height="14"/><rect x="82" y="132" width="4" height="14"/>
    <rect x="58.5" y="8" width="3" height="14"/><rect x="58.5" y="30" width="3" height="14"/><rect x="58.5" y="52" width="3" height="14"/>
    <text x="60" y="118" text-anchor="middle" font-family="Barlow Condensed, Arial Narrow, sans-serif" font-weight="800" font-size="${rwy.length > 2 ? 32 : 40}">${rwy}</text></g></svg>`;
}

/* ---------- templates ---------- */
function classic(e, v){
  return `<div class="c-top"><span>${e.apt}</span><span>${e.date}</span></div>
    <div><div class="c-title">${e.milestone}</div><div class="c-name">${e.name}</div>${noteHtml(e)}</div>
    <div class="c-mid">${v.showDetails ? `<dl>${details(e).map(([a,b]) => `<dt>${a}</dt><dd>${b}</dd>`).join("")}</dl>` : "<div></div>"}${v.showArt ? rwySvg(e.rwy) : ""}</div>
    ${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}`;
}
function runway(e, v){
  return `<div class="rw-text">
      <div class="rw-eyebrow">${e.apt} · ${e.date}</div>
      <div><div class="c-title">${e.milestone}</div><div class="c-name">${e.name}</div>${noteHtml(e)}</div>
      ${v.showDetails ? `<div class="rw-dl">${details(e).map(([a,b]) => `<div><small>${a}</small><b>${b}</b></div>`).join("")}</div>` : ""}
      ${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}
    </div>
    ${v.showArt ? `<div class="rw-strip"><div class="rw-cl"></div><div class="rw-num">${e.rwy}</div><div class="rw-bars">${"<i></i>".repeat(6)}</div></div>` : ""}`;
}
function boarding(e, v){
  const stops = e.route ? e.route.split(/[\s\-–>,/]+/).filter(Boolean) : [];
  const from = stops[0] || e.apt;
  let to = stops.length > 1 ? stops[stops.length-1] : e.apt;
  if (stops.length > 2 && to === from) to = stops[Math.floor(stops.length/2)];
  const plane = `<svg viewBox="0 0 100 100" aria-hidden="true"><g fill="currentColor" transform="rotate(90 50 50)">${PLANE}</g></svg>`;
  const grid = v.showDetails
    ? `<div><small>Pilot</small><b class="c-name">${e.name}</b></div><div><small>Flight</small><b>${e.tail}</b></div><div><small>Date</small><b>${e.date}</b></div><div><small>Aircraft</small><b>${e.type}</b></div><div><small>Gate</small><b>RWY ${e.rwy}</b></div><div><small>Seat</small><b>PIC</b></div>`
    : `<div><small>Pilot</small><b class="c-name">${e.name}</b></div><div><small>Date</small><b>${e.date}</b></div>`;
  return `<div class="bp"><div class="bp-main">
      <div class="bp-head"><span>BOARDING PASS</span><span>PILOT IN COMMAND</span></div>
      <div class="bp-route"><div><small>FROM</small><b>${from}</b></div><div class="bp-line">${v.showArt ? plane : ""}</div><div><small>TO</small><b>${to}</b></div></div>
      <div class="c-title">${e.milestone}</div>
      <div class="bp-grid">${grid}</div>
      ${noteHtml(e)}
      ${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}
    </div>
    <div class="bp-stub"><div><small>Pilot</small><b>${e.name}</b></div><div><small>${e.signer}</small><b>${e.cfi}</b></div><div><small>Flight time</small><b>${e.time ? e.time + " HRS" : "—"}</b></div><div class="bp-bar"></div></div></div>`;
}
function logbook(e, v){
  return `<div class="lb-head"><span>PILOT LOGBOOK</span><span>PAGE 01</span></div>
    <div class="lb-head" style="align-items:baseline;justify-content:flex-start;gap:2cqi"><span>PILOT</span><span class="c-name">${e.name}</span></div>
    ${v.showDetails ? `<div class="lb-wrap"><table class="lb-table"><thead><tr><th style="width:24%">DATE</th><th style="width:22%">MAKE / MODEL</th><th style="width:16%">IDENT</th><th>ROUTE</th><th style="width:11%">TOTAL</th></tr></thead>
      <tbody><tr><td>${e.date}</td><td>${e.type}</td><td>${e.tail}</td><td>${e.route || e.apt + " RWY " + e.rwy}</td><td>${e.time || "—"}</td></tr></tbody></table></div>` : "<div></div>"}
    <div class="lb-rmk"><small>REMARKS AND ENDORSEMENTS</small><div class="lb-ms">${e.milestone}!</div>${noteHtml(e)}${v.showRmk ? `<small>${rmkText(e)}</small>` : ""}</div>
    <div class="lb-sign"><span>${e.signer.toUpperCase()} SIGNATURE</span><b>${e.cfi}</b></div>
    ${v.showArt ? `<div class="lb-stamp">SIGNED<br>OFF<small>${e.apt}</small></div>` : ""}`;
}
function blueprint(e, v){
  const art = `<svg viewBox="0 0 120 100" aria-hidden="true" fill="none" stroke="#EAF2FF" stroke-width=".6">
      <circle cx="60" cy="46" r="42" stroke-dasharray="2 2" opacity=".5"/>
      <line x1="60" y1="0" x2="60" y2="92" stroke-dasharray="6 2 1 2" opacity=".6"/>
      <g transform="translate(10 0)">${PLANE.replace("<path", '<path stroke="#EAF2FF" stroke-width=".7"')}</g>
      <line x1="20" y1="94" x2="100" y2="94"/><path d="M20 94l3-1.5v3zM100 94l-3-1.5v3z" fill="#EAF2FF"/>
      <line x1="20" y1="90" x2="20" y2="97"/><line x1="100" y1="90" x2="100" y2="97"/>
      <text x="60" y="92.5" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="3.4" fill="#EAF2FF" stroke="none">${e.tail} · ${e.type.toUpperCase()}</text>
      <text x="104" y="12" font-family="IBM Plex Mono, monospace" font-size="3.2" fill="var(--acc)" stroke="none">RWY ${e.rwy}</text>
    </svg>`;
  const rows = v.showDetails ? details(e).map(([a,b]) => `<span>${a.toUpperCase()}</span><b>${b}</b>`).join("") : "";
  return `<div class="bpr-title"><small>${e.apt} · ${e.date}</small><div class="c-title">${e.milestone}</div>${noteHtml(e)}${v.showRmk ? `<small>${rmkText(e)}</small>` : ""}</div>
    ${v.showArt ? `<div class="bpr-art">${art}</div>` : ""}
    <div class="bpr-block"><span>PILOT</span><b class="c-name">${e.name}</b>${rows}<span>SHEET</span><b>1 OF 1</b></div>`;
}
function vintage(e, v){
  const wing = `<path d="M44 22 C34 12 18 8 0 10 C10 14 18 17 26 20 C16 19 8 19 2 21 C12 24 21 25 29 26 C22 27 15 28 9 30 C19 32 30 31 44 28 Z"/>`;
  const wings = `<svg class="vt-wings" viewBox="0 0 100 40" aria-hidden="true"><g fill="#1D2B4F">${wing}<g transform="translate(100 0) scale(-1 1)">${wing}</g><circle cx="50" cy="24" r="10"/></g>
    <circle cx="50" cy="24" r="7.5" fill="var(--acc)"/><text x="50" y="27.4" text-anchor="middle" font-family="Barlow Condensed, sans-serif" font-weight="800" font-size="${e.rwy.length > 2 ? 7 : 9}" fill="#F1E6CF">${e.rwy}</text></svg>`;
  return `<div class="vt-top">★ ${e.apt} · ${e.date} ★</div>
    <div class="c-title">${e.milestone}</div>
    ${v.showArt ? wings : ""}
    <div class="vt-ribbon"><div class="c-name">${e.name}</div></div>
    ${noteHtml(e)}
    ${v.showDetails ? `<div class="vt-dl">${details(e).map(([a,b]) => `<span>${a} ${b}</span>`).join("")}</div>` : ""}
    ${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}`;
}
function minimal(e, v){
  return `${v.showArt ? `<div class="mn-ghost" aria-hidden="true">${e.rwy}</div>` : ""}
    <div class="mn-top"><span><i></i>${e.date}</span><span>${e.apt}</span></div>
    <div class="mn-body"><div class="c-title">${e.milestone}</div><div class="c-name">${e.name}</div>${noteHtml(e)}</div>
    <div class="mn-dl">${v.showDetails ? details(e).map(([a,b]) => `<div><small>${a}</small><b>${b}</b></div>`).join("") : ""}${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}</div>`;
}
function patch(e, v){
  const top = e.milestone.toUpperCase(), bot = e.name.toUpperCase();
  const fs1 = Math.min(26, 300 / Math.max(top.length, 1)).toFixed(1);
  const fs2 = Math.min(22, 290 / Math.max(bot.length, 1)).toFixed(1);
  const badge = `<svg viewBox="0 0 300 300" aria-hidden="true">
      <defs>
        <path id="pt-top" d="M 26 150 A 124 124 0 0 1 274 150"/>
        <path id="pt-bot" d="M 12 150 A 138 138 0 0 0 288 150"/>
        <linearGradient id="pt-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2E6FB7"/><stop offset="1" stop-color="#A8D0F2"/></linearGradient>
        <clipPath id="pt-clip"><circle cx="150" cy="150" r="111"/></clipPath>
      </defs>
      <circle cx="150" cy="150" r="148" fill="var(--acc)"/>
      <circle cx="150" cy="150" r="146" fill="none" stroke="#14213D" stroke-width="2" stroke-dasharray="3 3"/>
      <circle cx="150" cy="150" r="117" fill="#14213D"/>
      <circle cx="150" cy="150" r="111" fill="url(#pt-sky)"/>
      <g clip-path="url(#pt-clip)">
        <rect x="128" y="196" width="44" height="80" fill="#2C323A"/>
        <g fill="#F4F6F1"><rect x="131" y="250" width="3" height="12"/><rect x="137" y="250" width="3" height="12"/><rect x="143" y="250" width="3" height="12"/><rect x="154" y="250" width="3" height="12"/><rect x="160" y="250" width="3" height="12"/><rect x="166" y="250" width="3" height="12"/>
        <text x="150" y="240" text-anchor="middle" font-family="Barlow Condensed, sans-serif" font-weight="800" font-size="${e.rwy.length > 2 ? 20 : 26}">${e.rwy}</text></g>
      </g>
      <g fill="#FFFFFF"><circle cx="72" cy="112" r="3"/><circle cx="230" cy="104" r="3"/><circle cx="96" cy="74" r="2.4"/><circle cx="206" cy="70" r="2.4"/><circle cx="150" cy="52" r="2"/></g>
      <g transform="translate(150 122) scale(1.15) translate(-50 -50)" fill="#F4F1E8">${PLANE}</g>
      <text font-family="Barlow Condensed, sans-serif" font-weight="800" font-size="${fs1}" fill="#14213D" letter-spacing="1.5"><textPath href="#pt-top" startOffset="50%" text-anchor="middle">${top}</textPath></text>
      <text font-family="Barlow Condensed, sans-serif" font-weight="800" font-size="${fs2}" fill="#14213D" letter-spacing="1.5"><textPath href="#pt-bot" startOffset="50%" text-anchor="middle">${bot}</textPath></text>
    </svg>`;
  return `${v.showArt ? `<div class="pt-badge">${badge}</div>` : ""}
    <div class="pt-side"><small>${e.apt} · ${e.date}</small><div class="c-title">${e.milestone}</div><div class="c-name">${e.name}</div>${noteHtml(e)}
      ${v.showDetails ? `<dl class="pt-dl">${details(e).map(([a,b]) => `<dt>${a}</dt><dd>${b}</dd>`).join("")}</dl>` : ""}
      ${v.showRmk ? `<div class="c-rmk">${rmkText(e)}</div>` : ""}</div>`;
}
const RENDER = {sectional:classic, shirttail:classic, night:classic, runway, boarding, logbook, blueprint, vintage, minimal, patch};

function render(){
  const v = vals();
  const e = {}; Object.keys(v).forEach(k => { e[k] = typeof v[k] === "string" ? esc(v[k]) : v[k]; });
  const cert = q("[data-cert]");
  if (!cert) return;
  cert.className = ["cert", "t-" + v.tpl, ["sectional","shirttail","night"].includes(v.tpl) ? "lay-classic" : "",
    v.layout === "portrait" ? "portrait" : "", v.showArt ? "" : "no-art", v.font ? "nf-" + v.font : ""].filter(Boolean).join(" ");
  if (v.acc) cert.style.setProperty("--acc", v.acc); else cert.style.removeProperty("--acc");
  cert.style.setProperty("--tsize", Math.min(11.5, 86 / (v.milestone.length * 0.47)).toFixed(2) + "cqi");
  cert.innerHTML = (RENDER[v.tpl] || classic)(e, v);

  const cw = q("[data-custom-wrap]");
  if (cw) { cw.hidden = !v.isCustom; const ci = f("custom"); if (ci) { ci.disabled = !v.isCustom; ci.required = v.isCustom; } }
  root.querySelectorAll("[data-sign-label]").forEach(el => { el.textContent = v.signer; });
  const outAcc = q('[data-out="accent"]'); if (outAcc) outAcc.value = v.accName;
  const outShow = q('[data-out="show"]');
  if (outShow) outShow.value = [v.showArt && "Artwork", v.showDetails && "Flight details", v.showRmk && "Remarks line"].filter(Boolean).join(", ") || "Title and name only";
  const outSign = q('[data-out="signer-role"]'); if (outSign) outSign.value = v.signer;
  document.querySelectorAll("[data-milestone-chip]").forEach(c => c.setAttribute("aria-pressed", String(c.dataset.milestoneChip === val("milestone"))));
  const tname = (TEMPLATES.find(t => t.id === v.tpl) || {}).name;
  cert.setAttribute("aria-label", `${tname} ${v.layout} print preview: ${v.milestone} for ${v.name}, ${v.date}, ${v.type} ${v.tail}, runway ${v.rwy} at ${v.apt}`);
}

function setMilestone(name){
  const sel = f("milestone");
  if (!sel || ![...sel.options].some(o => o.value === name)) return false;
  sel.value = name; render();
  const target = document.getElementById("designer") || root;
  target.scrollIntoView({behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"});
  return true;
}

buildControls();
root.addEventListener("input", render);
root.addEventListener("change", render);
document.addEventListener("click", ev => {
  const chip = ev.target.closest("[data-milestone-chip]");
  if (chip && setMilestone(chip.dataset.milestoneChip)) ev.preventDefault();
});
window.ClearedSoloDesigner = {setMilestone, render};
render();
})();
